import type * as React from 'react';

import { cn } from '../../utils';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelClassName?: string;
  containerClassName?: string;
  icon?: React.ReactNode;
  ref?:
    | React.RefObject<HTMLInputElement>
    | ((instance: HTMLInputElement) => void);
}

function Input({ className, type, containerClassName, ...props }: InputProps) {
  return (
    <div className={cn('relative flex flex-col', containerClassName)}>
      {props.label && (
        <p
          className={cn(
            'mb-1 font-medium text-gray-800 text-sm',
            props.labelClassName
          )}
        >
          {props.label}
        </p>
      )}
      <input
        type={type}
        data-slot="input"
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-[16px] ring-offset-background file:border-0 file:bg-transparent file:font-medium file:text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        {...props}
      />
      {props.icon && (
        <div className="-translate-y-1/2 absolute top-1/2 right-3">
          {props.icon}
        </div>
      )}
    </div>
  );
}

export { Input };
